<template>
  <div class="main-container flex flex-center">
    <div class="main-box">
      <!--头部导航-->
      <div class="box-header flex flex-center">
        <div class="box-header-left flex flex-center">
          <span
            class="header-span"
            :class="{ 'header-span-active': active1 == 1 }"
            @click="activeChange(1, 'time')"
            >{{ $t("m.options.listTab.time") }}</span
          >
          <span
            class="header-span"
            :class="{ 'header-span-active': active1 == 2 }"
            @click="activeChange(2, 'type')"
            >{{ $t("m.options.listTab.model") }}</span
          >
          <!--<span class="header-span" :class="{'header-span-active':active1==3}" @click="changeTab1(1,3)">烘焙时间</span>
          <span class="header-span" :class="{'header-span-active':active1==4}" @click="changeTab1(1,4)">运行时间</span>-->
          <span
            class="header-span"
            :class="{ 'header-span-active': active1 == 5 }"
            @click="activeChange(5, 'name')"
            >{{ $t("m.options.listTab.name") }}</span
          >
        </div>
        <div class="box-header-right">
          <el-button
          type="primary"
          icon="el-icon-plus"
          class="active-icon"
          @click="deviceBindDialog = true"
        >
          {{ $t("m.deviceManage.bindDevice.button.bindBtn") }}
        </el-button>
          <el-button
            type="primary"
            icon="el-icon-search"
            class="active-icon  header-btn"
            @click="searcheDialogVisible = true"
          ></el-button>
          <el-button type="primary"
          class="active-icon header-btn"
          @click="reset()"
          >
          <div style="display:flex;align-items: center;">
            <img src="@/assets/icons/reset.png" alt="" style="width: 18px;padding-right: 5px;">
            <span> {{ $t('m.common.reset') }}</span>
          </div>
      
          </el-button>
          <el-button
            v-if="role !== 2"
            type="primary"
            icon="el-icon-save"
            class="active-icon header-btn"
            @click="addDeviceDialog = true"
          >
            {{ $t("m.button.addDevice") }}
          </el-button>
        </div>
      </div>
      <!--内容-->
      <div
        style="height:calc(100% - 160px);position: relative;"
      >
        <el-row 
          class="box-content" 
          style="max-height:calc(100% - 45px);"
        >
          <el-col 
            :span="7"
            :md="11"
            :sm="24"
            :lg="11"
            :xl="7"
            @click.native="checkDevice(item)"
            :class="[
              item.device.id == activeDeviceId && item.device.username == activeUserName
                ? 'box-item box-sb box-active'
                : 'box-item box-sb',
            ]"
            v-for="item in bindDeviceList"
            :key="item.device.id"
          >
            <div class="box-item-img">
              <img
                v-if="item.id == activeBindId"
                src="../../assets/icons/设备图2@3x.png"
              />
              <img v-else src="../../assets/icons/设备图1@3x.png" />
              <div style="text-align: left;">
                <div class="sb-name">{{$t('m.options.deviceSearchOptions.deviceName')}}：{{ item.device.name }}</div>
                <div class="sb-name">{{$t('m.options.deviceSearchOptions.deviceNumber')}}：{{ item.deviceType.name }}</div>
                <div class="sb-name">{{$t('m.userList.userTable.username')}}：{{ role !== 1 ? userName : item.device.username || '--' }}</div>
              </div>
            </div>
          </el-col>
        </el-row>
        <div class="table-footer">
          <el-pagination
              v-show="page.total > 0"
              background
              align="right"
              layout="prev, pager, next"
              @current-change="devicePageChange"
              :page-size="page.pageSize"
              :total="page.total"
          >
          </el-pagination>
        </div>
      </div>

      <div class="sb-footer">
        <el-divider style="margin:0 0 15px 0;"></el-divider>
        <div class="sb-footer-line" style="margin-bottom:15px;">
          <el-button type="primary"
            ><span>{{ $t("m.deviceIndex.beanTemper") }}：</span
            ><span class="value">{{ mqttInfo.sdTemperature }}</span></el-button
          >
          <el-button type="primary"
            ><span>{{ $t("m.deviceIndex.inletAirTemperature") }}：</span
            ><span class="value">{{
              isReverseTemperatureDevice ? mqttInfo.outSideTemperature : mqttInfo.inWindTemperature
            }}</span></el-button
          >
          <el-button type="primary"
            ><span>{{ $t("m.deviceIndex.outWindTemper") }}：</span
            ><span class="value">{{
              mqttInfo.outWindTemperature
            }}</span></el-button
          >
          <el-button type="primary"
            ><span>{{ $t("m.deviceIndex.environmentTemper") }}：</span
            ><span class="value">{{
              isReverseTemperatureDevice ? mqttInfo.inWindTemperature : mqttInfo.outSideTemperature
            }}</span></el-button
          >
        </div>
        <div class="sb-footer-line">
          <el-button type="primary"
            ><span>{{ $t("m.deviceIndex.heating") }}：</span
            ><span class="value">{{ mqttInfo.fire }}</span></el-button
          >
          <el-button type="primary"
            ><span>{{ $t("m.deviceIndex.airflow") }}：</span
            ><span class="value">{{ mqttInfo.wind }}</span></el-button
          >
          <el-button type="primary"
            ><span>{{ $t("m.deviceIndex.drum") }}：</span
            ><span class="value">{{ mqttInfo.speed }}</span></el-button
          >
          <el-button type="primary"
            ><span>{{ $t("m.deviceIndex.cooling") }}：</span
            ><span class="value">{{ mqttInfo.cold }}</span></el-button
          >
        </div>
      </div>
    </div>

    <div class="main-box border-1px-all">
      <section>
        <div class="flex flex-between">
          <div class="title-bc">{{ selectDevice.device.name }}</div>
          <div>
            <el-button
              type="primary"
              class="active-icon"
              @click="toNewCurve(selectDevice.device.id)"
            >
              {{ '新曲线' }}
            </el-button>
            <el-button
              v-if="role !== 1"
              @click="deviceUnbind()"
              type="primary"
              icon="el-icon-delete"
              class="active-icon"
            >
              {{ $t("m.button.unbind") }}
            </el-button>
            <el-button
              v-if="role == 1"
              type="primary"
              icon="el-icon-delete"
              class="active-icon"
              @click="deleteDevice()"
            >
              {{ $t("m.button.delete") }}
            </el-button>
          </div>
        </div>
        
        <div style="margin-top: 10px; color: #909399">
          <span class="gray-text"
            >{{ $t("m.deviceManage.bindDevice.systemSeriesNum") }}：</span
          >
          <span class="gray-text">{{ selectDevice.device.serino }}</span>
        </div>
        <div style="margin-top: 10px; color: #909399">
          <span class="gray-text"
            >{{ $t("m.deviceManage.bindDevice.deviceSeriesNum") }}：</span
          >
          <span class="gray-text">{{ selectDevice.device.orino }}</span>
        </div>
        <div style="margin-top: 10px; color: #909399">
          <span class="gray-text"
            >{{ $t("m.accountManage.username") }}：</span
          >
          <span class="gray-text">{{ role !== 1 ? userName : selectDevice.device.username || '--' }}</span>
        </div>
      </section>
      <section style="margin-top: 20px">
        <div class="row-box" style="background-color: #2D2F35FF">
          <el-row>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text"
                  >{{ $t("m.deviceManage.bindDevice.type") }}：</span
                >
                <span class="white-text">{{
                  selectDevice.deviceType.name
                }}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text"
                  >{{ $t("m.deviceManage.bindDevice.bindTime") }}：</span
                >
                <span class="white-text">{{
                  this.$moment(Number(selectDevice.device.createtime)).format(
                    "YYYY-MM-DD"
                  )
                }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text"
                  >{{ $t("m.deviceManage.bindDevice.bakeTime") }}：</span
                >
                <span class="white-text">
                  {{ timeFormatter(selectDevice.device.hbtime) }}
                </span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text"
                  >{{ $t("m.deviceManage.bindDevice.runTimeLength") }}：</span
                >
                <span class="white-text">{{
                  timeFormatter(selectDevice.device.runtime)
                }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text"
                  >{{ $t("m.deviceManage.bindDevice.deviceLocation") }}：</span
                >
                <span class="white-text">
                  <div type="" v-if="selectDevice.device.location == null">
                    {{ $t("m.deviceManage.bindDevice.notUpload") }}
                  </div>
                  <div type="" v-else>{{ selectDevice.device.location }}</div>
                </span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text"
                  >{{ $t("m.deviceManage.bindDevice.deviceStatus") }}：</span
                >
                <span class="white-text">
                  <div v-if="selectDevice.device.status == null">
                    {{ $t("m.deviceManage.bindDevice.notUpload") }}
                  </div>
                  <div v-else>{{ selectDevice.device.status }}</div>
                </span>
              </div>
            </el-col>
          </el-row>
        </div>
      </section>
      <section>
        <div class="box-header flex flex-center" style="margin-top: 30px">
          <div class="box-header-left flex flex-center">
            <span
              class="header-span"
              :class="{ 'header-span-active': active2 == 1 }"
              @click="active2 = 1"
              >{{ $t("m.deviceManage.bindDevice.curveList") }}</span
            >
            <span
              class="header-span"
              :class="{ 'header-span-active': active2 == 2 }"
              @click="active2 = 2"
              >{{ $t("m.deviceManage.bindDevice.runLog") }}</span
            >
            <!-- <span
              class="header-span"
              :class="{ 'header-span-active': active2 == 3 }"
              @click="active2 = 3"
              >{{ $t("m.deviceManage.bindDevice.roastLog") }}</span
            > -->
            <span
              class="header-span"
              :class="{ 'header-span-active': active2 == 4 }"
              @click="active2 = 4"
              >{{ $t("m.deviceManage.bindDevice.maintenanceReminder") }}</span
            >
            <span
              class="header-span"
              :class="{ 'header-span-active': active2 == 5 }"
              @click="active2 = 5"
              >{{ $t("m.deviceManage.bindDevice.maintenanceHistory") }}</span
            >
            <span
              class="header-span"
              :class="{ 'header-span-active': active2 == 6 }"
              @click="active2 = 6"
              >{{ $t("m.deviceManage.bindDevice.alarmLog") }}</span
            >
          </div>
        </div>
      </section>
      <!--曲线列表-->
      <section v-if="active2 == 1">
        <el-table
          :data="deviceReportList"
          border
          style="width: 100%"
          :empty-text="$t('m.options.deviceSearchOptions.noData')"
        >
          <el-table-column prop="report.name" :label="$t('m.table.name')">
          </el-table-column>
          <el-table-column
            prop="reportVo.suitVo.suit.hbtime"
            :label="$t('m.table.duration')"
            width="150"
          >
          </el-table-column>
          <el-table-column
            prop="report.createtime"
            :label="$t('m.table.date')"
            width="150"
          >
            <template slot-scope="scope">
              {{ $moment(Number(scope.row.report.createtime)).format("YYYY-MM-DD") }}
            </template>
          </el-table-column>
          <el-table-column
            prop="report.level"
            :label="$t('m.table.starLevel')"
            width="150"
          >
            <template slot-scope="scope">
              <el-rate
                :colors="['#FC9153', '#FC9153', '#FC9153']"
                disabled
                v-model="scope.row.report.level"
              ></el-rate>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('m.table.operation')"
            width="80"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                style="color: white"
                @click="reportDetailClick(scope.row)"
              >
                {{ $t("m.deviceManage.bindDevice.operation.detail") }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          align="right"
          layout="prev, pager, next"
          style="margin-top: 10px"
          @current-change="deviceReportPageChange"
          @size-change="deviceReportPageSizeChange"
          :page-size="deviceReportPage.pageSize"
          :total="deviceReportPage.total"
        >
        </el-pagination>
      </section>
      <!--运行日志-->
      <section v-if="active2 == 2">
        <el-table
          :data="deviceTimeList"
          border
          style="width: 100%;"
          show-summary
          :summary-method="getSummaries"
          :empty-text="$t('m.options.deviceSearchOptions.noData')"
        >
          <el-table-column
            prop="time"
            :label="
              $t('m.deviceManage.bindDevice.dialog.runTimeDialog.runTime')
            "
            width="150"
          >
            <template slot-scope="scope">
              {{ timeFormatter(scope.row.time) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="createtime"
            :label="$t('m.deviceManage.bindDevice.dialog.runTimeDialog.date')"
            :formatter="dateFormat"
            align="center"
          >
          </el-table-column>
        </el-table>
        <el-pagination
          background
          align="right"
          layout="prev, pager, next"
          style="margin-top: 10px"
          @current-change="deviceTimePageChange"
          @size-change="deviceTimePageSizeChange"
          :page-size="deviceRuntimePage.pageSize"
          :total="deviceRuntimePage.total"
        >
        </el-pagination>
      </section>
      <!--烘焙日志-->
      <section v-if="active2 == 3">
        <el-table
          :data="deviceHbTimeList"
          show-summary
          :summary-method="getSummaries"
          border
          style="width: 100%;"
          :empty-text="$t('m.options.deviceSearchOptions.noData')"
        >
          <el-table-column
            prop="time"
            :label="
              $t('m.deviceManage.bindDevice.dialog.runTimeDialog.timeLength')
            "
            width="150"
          >
            <template slot-scope="scope">
              {{ timeFormatter(scope.row.time) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="createtime"
            :label="$t('m.deviceManage.bindDevice.dialog.runTimeDialog.date')"
            :formatter="dateFormat"
            align="center"
          >
          </el-table-column>
        </el-table>
        <el-pagination
          background
          align="right"
          layout="prev, pager, next"
          style="margin-top: 10px"
          @current-change="deviceHbTimePageChange"
          @size-change="deviceHbTimePageSizeChange"
          :page-size="deviceHbPage.pageSize"
          :total="deviceHbPage.total"
        >
        </el-pagination>
      </section>
      <!--维保提醒-->
      <section v-show="active2 == 4">
        <el-table
          :data="deviceRemainList"
          border
          style="width: 100%;"
          :empty-text="$t('m.options.deviceSearchOptions.noData')"
        >
          <el-table-column
            prop="createtime"
            :formatter="dateFormat"
            :label="$t('m.deviceManage.bindDevice.date')"
            width="150"
          >
          </el-table-column>
          <el-table-column
            prop="type"
            :label="$t('m.deviceManage.bindDevice.triggerCondition')"
          >
          </el-table-column>
          <el-table-column
            prop="content"
            :label="$t('m.deviceManage.bindDevice.content')"
          >
          </el-table-column>
          <el-table-column
          :label="$t('m.deviceManage.bindDevice.operation.name')"
          width="120"
          v-if="role !== 1"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              style="color: white"
              @click="deviceRemainEdit(scope.row)"
            >
              {{ $t("m.deviceManage.bindDevice.operation.edit") }}
            </el-button>
            <el-button
              type="text"
              size="small"
              style="color: white"
              @click="deviceRemainDelete(scope.row)"
            >
              {{ $t("m.deviceManage.bindDevice.operation.delete") }}
            </el-button>
          </template>
        </el-table-column>
        </el-table>
        <div class="flex flex-between" style="margin-top: 10px;">
          
          <el-button v-if="role !== 1" type="primary" icon="el-icon-plus" class="active-icon" align="left" @click="addRemainDialog = true">新增维保提醒</el-button>

          <el-pagination
          style="margin-top: 10px; width: 100%;"
            background
            align="right"
            layout="prev, pager, next"
            @current-change="deviceRemainPageChange"
            @size-change="deviceRemainPageSizeChange"
            :page-size="deviceRemainPage.pageSize"
            :total="deviceRemainPage.total"
          >
          </el-pagination>
        </div>
      </section>
      <!--维保历史-->
      <section v-if="active2 == 5">
        <el-table
          :data="deviceMaintainList"
          border
          style="width: 100%;"
          :empty-text="$t('m.options.deviceSearchOptions.noData')"
        >
          <el-table-column
            prop="createtime"
            :formatter="dateFormat"
            :label="
              $t(
                'm.deviceManage.bindDevice.dialog.maintainDialog.tabMaintainLog.date'
              )
            "
            width="150"
          >
          </el-table-column>
          <el-table-column
            prop="content"
            :label="
              $t(
                'm.deviceManage.bindDevice.dialog.maintainDialog.tabMaintainLog.solution'
              )
            "
            align="center"
          >
          </el-table-column>
          <el-table-column
          :label="$t('m.deviceManage.bindDevice.operation.name')"
          width="150"
          v-if="role !== 1"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              style="color: white"
              @click="deviceMaintainEdit(scope.row)"
            >
              {{ $t("m.deviceManage.bindDevice.operation.edit") }}
            </el-button>
            <el-button
              type="text"
              size="small"
              style="color: white"
              @click="deviceMaintainDelete(scope.row)"
            >
              {{ $t("m.deviceManage.bindDevice.operation.delete") }}
            </el-button>
          </template>
        </el-table-column>
        </el-table>
        <div class="flex flex-between" style="margin-top: 10px;">
          <el-button type="primary" icon="el-icon-plus" class="active-icon" align="left" @click="deviceMaintainEdit(0)" v-if="role !== 1">新增维保历史</el-button>

          <el-pagination
          style="margin-top: 10px; width: 100%;"
            background
            align="right"
            layout="prev, pager, next"
            @current-change="deviceMaintainPageChange"
            @size-change="deviceMaintainPageSizeChange"
            :page-size="deviceMaintainPage.pageSize"
            :total="deviceMaintainPage.total"
          >
          </el-pagination>
        </div>
      </section>
      <!--报警日志-->
      <section v-show="active2 == 6">
        <el-table
          :data="deviceWarnList"
          border
          style="width: 100%;"
          :empty-text="$t('m.options.deviceSearchOptions.noData')"
        >
          <el-table-column
            prop="type"
            :label="$t('m.deviceManage.bindDevice.tableType')"
           
          >
          </el-table-column>
          <el-table-column
            prop="lastDateTime"
            :formatter="dateFormat1"
            :label="$t('m.deviceManage.bindDevice.date')"
            align="center"
     
          >
          </el-table-column>
          <el-table-column
            prop="count"
            :label="$t('m.deviceManage.bindDevice.count')"
            align="center"
          >
          </el-table-column>
        </el-table>
        <!-- <div class="flex flex-between" style="margin-top: 10px;"> -->
          <el-pagination
          v-if="deviceWarnPage.total > 0"
          style="margin-top: 10px;"
            background
            align="right"
            layout="prev, pager, next"
            @current-change="deviceWarnPageChange"
            @size-change="deviceWarnPageSizeChange"
            :page-size="deviceWarnPage.pageSize"
            :total="deviceWarnPage.total"
          >
          </el-pagination>
        <!-- </div> -->
      </section>
    </div>
    <!--------搜索弹框---------->
    <el-dialog
      :title="$t('m.chart.table.search')"
      :visible.sync="searcheDialogVisible"
      width="500px"
      :show-close="false"
    >
      <div>
        <div class="flex flex-center" style="margin-bottom:10px;gap: 20px">
          <el-select v-model="params.searchParamName" style="width: 150px;" placeholder="">
            <el-option
                    v-for="item in searchOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    {{ item.label }}</el-option>
          </el-select>
            <div style="width: 100%">
              <el-input v-if="params.searchParamName !== 'deviceType'"
                v-model="params.searchParamValue"
                :placeholder="$t('m.chart.table.placeholder3')"
              ></el-input>
              <el-select  style="width: 100%" v-else v-model="params.searchParamValue" placeholder="请选择">
                <el-option
                        v-for="item in addDeviceForm.deviceTypeOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        {{ item.name }}</el-option>
              </el-select>
            </div>
        </div>
        <div style="width: 100%">
          <el-select
            v-model="isSelectedUser"
            style="width: 100%"
            filterable
            remote
            reserve-keyword
            placeholder="请输入用户名进行查找"
            :remote-method="getUserList"
            :loading="userLoading">
            <el-option
              v-for="item in userList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
      </div>
      <div slot="footer" class="flex flex-center">
        <div @click="searcheDialogVisible = false" class="dialog-footer-btn">
          {{ $t("m.chart.table.cancel") }}
        </div>
        <div @click="changeTab1" type="primary" class="dialog-footer-btn">
          {{ $t("m.chart.table.confirm") }}
        </div>
      </div>
    </el-dialog>
    <!--------添加设备---------->
    <el-dialog
      :title="$t('m.button.addDevice')"
      width="30%"
      center
      :modal-append-to-body="false"
      :visible.sync="addDeviceDialog"
    >
      <el-row>
        <el-form
          ref="addDevice"
          :rules="addDeviceForm.rules"
          :model="addDeviceForm"
          label-width="80px"
        >
          <el-form-item :label="$t('m.options.deviceSearchOptions.deviceName')">
            <el-input
              v-model="addDeviceForm.deviceName"
              :placeholder="
                $t('m.deviceManage.bindDevice.dialog.bindDialog.placeholder2')
              "
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('m.options.deviceSearchOptions.deviceNumber')"
          >
            <el-select v-model="addDeviceForm.deviceType" placeholder="">
              <el-option
                v-for="item in addDeviceForm.deviceTypeOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('m.options.deviceSearchOptions.seriesNumber')"
          >
            <el-input
              v-model="addDeviceForm.serino"
              :placeholder="
                $t('m.deviceManage.bindDevice.dialog.bindDialog.placeholder')
              "
            ></el-input>
          </el-form-item>
        </el-form>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDeviceDialog = false">{{
          $t("m.chart.table.cancel")
        }}</el-button>
        <el-button type="primary" @click="addDeviceClick">{{
          $t("m.chart.table.confirm")
        }}</el-button>
      </span>
    </el-dialog>
    <!-- 绑定设备 -->
    <el-dialog
      :title="$t('m.deviceManage.bindDevice.dialog.bindDialog.title')"
      :visible.sync="deviceBindDialog"
      width="500px"
      :show-close="false"
    >
      <div>
        <div class="flex flex-center flex-between" style="margin-bottom:10px;">
          <el-form>
            <el-form-item
              :label="
                $t('m.deviceManage.bindDevice.dialog.bindDialog.seriesNumber')
              "
            >
              <el-input
                type="textarea"
                :rows="2"
                v-model="serino"
                style="width:450px"
                :placeholder="
                  $t('m.deviceManage.bindDevice.dialog.bindDialog.placeholder')
                "
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div slot="footer" class="flex flex-center">
        <div @click="deviceBindDialog = false" class="dialog-footer-btn">
          {{ $t("m.deviceManage.bindDevice.dialog.bindDialog.cancel") }}
        </div>
        <div @click="bindDevice" class="dialog-footer-btn">
          {{ $t("m.deviceManage.bindDevice.dialog.bindDialog.confirm") }}
        </div>
      </div>
    </el-dialog>
    <!--------添加维保提醒弹框---------->
    <el-dialog
      :title="
        isAddRemain
          ? $t('m.deviceManage.bindDevice.addMaintenanceReminder')
          : $t('m.deviceManage.bindDevice.editMaintenanceReminder')
      "
      center
      :modal-append-to-body="false"
      :visible.sync="addRemainDialog"
    >
      <el-form ref="" label-width="80px">
        <el-row style="padding: 10px 30px;">
          <el-col :span="12">
            <el-form-item :label="$t('m.deviceManage.bindDevice.tableType')">
              <el-select
                v-model="remainForm.type"
                :placeholder="$t('m.table.select')"
              >
                <el-option
                  :key="1"
                  :label="$i18n.locale === 'en-US' ? 'Running' : '运行'"
                  :value="1"
                >
                </el-option>
                <el-option
                  :key="2"
                  :label="$i18n.locale === 'en-US' ? 'Roasting' : '烘焙'"
                  :value="2"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('m.deviceManage.bindDevice.timeHour')">
              <el-select
                v-model="remainForm.time"
                filterable
                allow-create
                default-first-option
                :placeholder="$t('m.table.select')"
              >
                <el-option :key="1" label="150" :value="150"> </el-option>
                <el-option :key="2" label="200" :value="200"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="$t('m.deviceManage.bindDevice.content')">
          <el-input
            type="textarea"
            v-model="remainForm.content"
            auto-complete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addRemainDialog = false">{{
          $t("m.deviceManage.bindDevice.dialog.bindDialog.cancel")
        }}</el-button>
        <el-button type="primary" @click="addRemain">{{
          $t("m.deviceManage.bindDevice.dialog.bindDialog.confirm")
        }}</el-button>
      </div>
    </el-dialog>
    <!--------添加维保弹框---------->
    <el-dialog
      :title="
        isAddMaintain
          ? $t('m.deviceManage.bindDevice.addMaintenanceHistory')
          : $t('m.deviceManage.bindDevice.editMaintenanceHistory')
      "
      center
      :modal-append-to-body="false"
      :visible.sync="addMaintainDialog"
    >
      <el-form ref="" label-width="80px">
        <el-form-item :label="$t('m.deviceManage.bindDevice.content')">
          <el-input
            type="textarea"
            v-model="maintainForm.content"
            auto-complete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addMaintainDialog = false">{{
          $t("m.deviceManage.bindDevice.dialog.bindDialog.cancel")
        }}</el-button>
        <el-button type="primary" @click="addMaintain">{{
          $t("m.deviceManage.bindDevice.dialog.bindDialog.confirm")
        }}</el-button>
      </div>
    </el-dialog>
    <!--------曲线详情---------->
    <el-drawer

      :visible.sync="reportDetailDialog"
      size="40%"
    >
    <template slot="title">
      <span style="color: #e2e2e2;cursor: pointer" @click="reportDetailDialog = false"><i class="el-icon-arrow-left"></i>返回</span>
    </template>
      <report-chart
        @finish="reportDetailLoadingFinish"
        :report-id="selectReportId"
        :key="reportKey"
        :url="selectedUrl"
        @curve-deleted="handleCurveDeleted"
      ></report-chart>
    </el-drawer>
  </div>
</template>

<script>
import mqtt from "mqtt";
//import report from '@/components/report/report'
import report from "@/components-online/curve/report";
import { getDwRorValue, getDwValue, getHJWValue, isValidDeviceInfo,
  getRfValue, getPFWValue, getRFWValue,getHotValue, getGtValue, getLQValue} from '../../utils/utils';
import { reverseTemperatureDevices } from '@/assets/functions/axiosServer';
export default {
  name: "onAllUserDeviceList",
  components: {
    "report-chart": report,
  },
  data() {
    return {
      activeBindId: 0,
      bindDeviceList: [],
      activeDeviceId: 0,
      activeUserName: "",
      activeSerino: "",
      selectDeviceNewMsgCount: 0,
      maintainLabel: "维保提醒",
      historyMsg: [],
      newMsgList: [],
      historyPage: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },
      newMsgPage: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },
      selectMsgIds: [],
      mqttInfo: {
        sdTemperature: this.$t("m.deviceManage.bindDevice.notUpload"), //豆温
        inWindTemperature: this.$t("m.deviceManage.bindDevice.notUpload"), //热风温
        outSideTemperature: this.$t("m.deviceManage.bindDevice.notUpload"), //环境温
        outWindTemperature: this.$t("m.deviceManage.bindDevice.notUpload"), //排风温
        fire: this.$t("m.deviceManage.bindDevice.notUpload"),
        wind: this.$t("m.deviceManage.bindDevice.notUpload"),
        speed: this.$t("m.deviceManage.bindDevice.notUpload"),
        cold: this.$t("m.deviceManage.bindDevice.notUpload"),
      },
      client: {},
      msg: "",
      mqttMsg: {},
      selectDevice: {
        device: { name: "", location: null, serino: "" },
        deviceType: { name },
        bind: { createtime: "" },
      },
      deviceReportList: [],
      deviceReportPage: {
        pageSize: 7,
        pageNum: 1,
        total: 0,
      },
      deviceTimeList: [],
      deviceRuntimePage: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      deviceHbTimeList: [],
      deviceHbPage: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      deviceMaintainList: [],
      deviceMaintainPage: {
        pageNum: 1,
        pageSize: 5,
        total: 0,
      },
      deviceRemainList: [],
      deviceRemainPage: {
        pageNum: 1,
        pageSize: 5,
        total: 0,
      },
      deviceWarnList: [],
      deviceWarnPage: {
        pageNum: 1,
        pageSize: 5,
        total: 0,
      },
      reportDetailDialog: false,
      selectReportId: 0,
      selectedUrl: "",
      detailReport: {
        name: "",
        level: "",
        type: "",
        weight: 0,
        color: "",
        user: {},
        suitVo: {
          bean: {
            name: "",
          },
          lineVoList: [], //曲线数据
          height: 0,
          weight: 0,
        },
      }, //曲线详情
      reportKey: 0,
      loading: undefined,
      serino: "",
      maintainForm: {
        type: 1,
        worker: "",
        content: "",
        item: "",
        rules: [],
      },
      remainForm: {
        type: 1,
        time: "",
        content: "",
        id: "",
      },
      active1: 1,
      active2: 1,
      page: {
        pageSize: 20,
        pageNum: 1,
        total: 0,
      },
      params: {
        searchParamName: "deviceName",
        searchParamValue: "",
      },
      searchOptions: [
        {
          value: "deviceName",
          label: this.$t("m.options.deviceSearchOptions.deviceName"),
        },
        {
          value: "deviceCode",
          label: this.$t("m.options.deviceSearchOptions.seriesNumber"),
        },
        {
          value: "deviceSerial",
          label: this.$t("m.options.deviceSearchOptions.systemSeriesNum"),
        },
        {
          value: "deviceStatus",
          label: this.$t("m.options.deviceSearchOptions.status"),
        },
        {
          value: "deviceType",
          label: this.$t("m.options.deviceSearchOptions.deviceType"),
        },
      ],
      searcheDialogVisible: false,
      role: 0,
      addDeviceDialog: false,
      addDeviceForm: {
        deviceName: "",
        serino: "",
        deviceType: null,
        deviceTypeOptions: [
          // {value: 391, label: 'M2E'},
          // {value: 392, label: 'M5E'},
          // {value: 394, label: 'PEAK'},
        ],
        rules: {
          name: [
            {
              required: true,
              message:
                this.$i18n.locale === "en-US"
                  ? "Please enter the name"
                  : "请输入名称",
              trigger: "blur",
            },
          ],
          serino: [
            {
              required: true,
              message:
                this.$i18n.locale === "en-US"
                  ? "Please enter the serial no."
                  : "请输入序列号",
              trigger: "blur",
            },
          ],
        },
      },
      column: 'time',
      deviceBindDialog: false,
      addMaintainDialog: false,
      isAddRemain: true, // 是否是新增维保提醒
      isAddMaintain: true, // 是否是新增维保
      addRemainDialog: false,
      userList: [],
      isSelectedUser: null,
      userLoading: false,
      userName: localStorage.getItem("userName"),
    };
  },

  computed: {
    isReverseTemperatureDevice() {
      const deviceList = (reverseTemperatureDevices || []);
      return deviceList.includes(this.activeUserName);
    }
  },

  mounted() {
    const id = this.$route.query?.id;
    if (id) {
      this.isSelectedUser = id;
    }
    this.changeTab1();
    this.getDeviceType();
    this.role = Number(localStorage.role);
  },
  beforeDestroy() {
    // this.client.end();
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null; // 重置为 null
    }
  },
  methods: {
    timeFormatter(value) {
      var secondTime = parseInt(value); // 秒
      var minuteTime = 0; // 分
      var hourTime = 0; // 小时
      var result = secondTime;
      if (secondTime > 60) {
        minuteTime = parseInt(secondTime / 60);
        secondTime = parseInt(secondTime % 60);
        if (minuteTime > 60) {
          hourTime = parseInt(minuteTime / 60);
          minuteTime = parseInt(minuteTime % 60);
        }
      } else if (secondTime == 60) {
        return "01:00";
      } else {
        if (secondTime < 10) {
          return "00:0" + result;
        } else {
          return "00:" + result;
        }
      }
      result = parseInt(secondTime);
      if (result < 10) {
        result = "0" + result;
      }
      if (minuteTime > 0) {
        if (minuteTime < 10) {
          result = "0" + parseInt(minuteTime) + ":" + result;
        } else {
          result = parseInt(minuteTime) + ":" + result;
        }
      }
      if (hourTime > 0) {
        if (hourTime < 10) {
          result = "0" + parseInt(hourTime) + ":" + result;
        } else {
          result = parseInt(hourTime) + ":" + result;
        }
      }
      return result;
    },
    checkDevice(item) {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
         background: "rgba(0, 0, 0, 0.7)",
      });
      this.loading = loading;
      this.activeDeviceId = item.device.id;
      this.activeUserName = item.device.username;
      this.activeSerino = item.device.serino;
      this.selectDevice = item;
      this.getDeviceReportList();
      this.getDeviceTime();
      this.getDeviceHbTime();
      //this.getHistoryMsg()
      // this.getNewMsg()
      //this.newMsgCount()
      this.getDeviceRemain(this.activeDeviceId);
      this.getDeviceMaintain(this.activeDeviceId);
      this.getDeviceWarn(this.activeDeviceId);
      // this.addTopic();
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
      this.getDeviceInfo();
      this.intervalId = setInterval(() => {
        this.getDeviceInfo();
      }, 5000);
      loading.close();
    },
    getCheckBindDevice() {
      this.getDeviceReportList();
      this.getDeviceTime();
      this.getDeviceHbTime();
      this.getDeviceRemain(this.activeDeviceId);
      this.getDeviceMaintain(this.activeDeviceId);
      this.getDeviceWarn(this.activeDeviceId);
    },
    dateFormat(row, column) {
      var date = row[column.property];
      if (!date) return '';
      date = Number(date);
      //.replace(/年|月/g, "-").replace(/日/g, " ")
      return this.$moment(date).format("YYYY-MM-DD");
    },
    dateFormat1(row, column) {
      var date = row[column.property];
      if (!date) return '';
      date = Number(date);
      return this.$moment(date).format("YYYY-MM-DD hh:mm");
    },
    getDeviceReportList() {
      this.$http
        .get("/manage/report/getOnlyListByDevice.do", {
          params: {
            pageSize: this.deviceReportPage.pageSize,
            pageNum: this.deviceReportPage.pageNum,
            serino: this.selectDevice.device.serino,
          },
        })
        .then(
          function(resp) {
            this.deviceReportList = resp.data.data.list;
            this.deviceReportPage.total = resp.data.data.total;
          }.bind(this)
        )
        .catch((err) => err);
    },
    deviceReportPageChange(val) {
      this.deviceReportPage.pageNum = val;
      this.getDeviceReportList();
    },
    deviceReportPageSizeChange(val) {
      this.deviceReportPage.pageSize = val;
      this.getDeviceReportList();
    },
    getDeviceTime() {
      this.$http
        .get("/manage/deviceLog/list.do", {
          params: {
            deviceId: this.selectDevice.device.id,
            type: 1,
            pageNum: this.deviceRuntimePage.pageNum,
            pageSize: this.deviceRuntimePage.pageSize,
          },
        })
        .then(
          function(resp) {
            this.deviceRuntimePage.total = resp.data.data.total;
            this.deviceTimeList = resp.data.data.list;
          }.bind(this)
        )
        .catch((err) => {
          console.info(err);
        });
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          const values = data.map((item) => Number(item[column.property]));
          if (!values.every((value) => isNaN(value))) {
            let totalTime = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] =
              (this.$i18n.locale === "en-US" ? "Total: " : "总和：") +
              this.timeFormatter(totalTime);
          } else {
            sums[index] = "N/A";
          }
        } else {
          sums[index] = "--";
        }
      });
      return sums;
    },
    deviceTimePageChange(val) {
      this.deviceRuntimePage.pageNum = val;
      this.getDeviceTime();
    },
    deviceTimePageSizeChange(val) {
      this.deviceRuntimePage.pageSize = val;
      this.getDeviceTime();
    },
    deviceHbTimePageChange(val) {
      this.deviceHbPage.pageNum = val;
      this.getDeviceHbTime();
    },
    deviceHbTimePageSizeChange(val) {
      this.deviceHbPage.pageSize = val;
      this.getDeviceHbTime();
    },
    getDeviceHbTime() {
      this.$http
        .get("/manage/deviceLog/list.do", {
          params: {
            deviceId: this.selectDevice.device.id,
            type: 2,
            pageNum: this.deviceHbPage.pageNum,
            pageSize: this.deviceHbPage.pageSize,
          },
        })
        .then(
          function(resp) {
            this.deviceHbPage.total = resp.data.data.total;
            this.deviceHbTimeList = resp.data.data.list;
          }.bind(this)
        )
        .catch((err) => {
          console.info(err);
        });
    },
    deviceMaintainPageChange(val) {
      this.deviceMaintainPage.pageNum = val;
      this.getDeviceMaintain(this.activeDeviceId);
    },
    deviceMaintainPageSizeChange(val) {
      this.deviceMaintainPage.pageSize = val;
      this.getDeviceMaintain(this.activeDeviceId);
    },
    getDeviceMaintain(deviceId) {
      this.$http
        .get("/manage/deviceMaintain/list.do", {
          params: {
            deviceId: deviceId,
            pageNum: this.deviceMaintainPage.pageNum,
            pageSize: this.deviceMaintainPage.pageSize,
          },
        })
        .then(
          function(resp) {
            this.deviceMaintainPage.total = resp.data.data.total;
            this.deviceMaintainList = resp.data.data.list;
          }.bind(this)
        )
        .catch((err) => {
          console.info(err);
        });
    },
    deviceRemainPageChange(val) {
      this.deviceRemainPage.pageNum = val;
      this.getDeviceRemain(this.activeDeviceId);
    },
    deviceRemainPageSizeChange(val) {
      this.deviceRemainPage.pageSize = val;
      this.getDeviceRemain(this.activeDeviceId);
    },
    getDeviceRemain(deviceId) {
      this.$http
        .get("/manage/deviceRemain/list.do", {
          params: {
            deviceId: deviceId,
            pageNum: this.deviceRemainPage.pageNum,
            pageSize: this.deviceRemainPage.pageSize,
          },
        })
        .then(
          function(resp) {
            this.deviceRemainPage.total = resp.data.data.total;
            this.deviceRemainList = resp.data.data.list;
            for (let index in this.deviceRemainList) {
              var typeText = "";
              if (this.deviceRemainList[index].type == 1) {
                typeText =
                  "每运行" + this.deviceRemainList[index].time + "小时";
              } else if (this.deviceRemainList[index].type == 2) {
                typeText =
                  "每烘焙" + this.deviceRemainList[index].time + "小时";
              }
              this.deviceRemainList[index].type = typeText;
            }
          }.bind(this)
        )
        .catch((err) => {
          console.info(err);
        });
    },
    deviceWarnPageChange(val) {
      this.deviceWarnPage.pageNum = val;
      this.getDeviceWarn(this.activeDeviceId);
    },
    deviceWarnPageSizeChange(val) {
      this.deviceWarnPage.pageSize = val;
      this.getDeviceWarn(this.activeDeviceId);
    },
    getDeviceWarn(deviceId) {
      this.$http
        .get("/manage/deviceWarn/list", {
          params: {
            deviceId: deviceId,
            pageNum: this.deviceWarnPage.pageNum,
            pageSize: this.deviceWarnPage.pageSize,
          },
        })
        .then(
          function(resp) {
            this.deviceWarnPage.total = resp.data.data.total;
            this.deviceWarnList = resp.data.data.list;
          }.bind(this)
        )
        .catch((err) => {
          console.info(err);
        });
    },
    reportDetailLoadingFinish() {
      this.loading.close()
    },
    reportDetailClick(report) {
      this.reportDetailDialog = true;
      this.selectReportId = report.report.id;
      this.reportKey = this.selectReportId;
      this.selectedUrl = report.report.note
    },
    devicePageChange(val) {
      console.info(val);
      this.page.pageNum = val;
      this.changeTab1();
    },
    changeTab1() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
         background: "rgba(0, 0, 0, 0.7)",
      });
      this.loading = loading;
      const url = "/manage/device/list";
      let params = {
            pageNum: this.page.pageNum,
            pageSize: this.page.pageSize,
            sort: {
              column: this.column
            }
        }
      if (this.params.searchParamName) {
        params[this.params.searchParamName] = this.params.searchParamValue;
      }
      if (this.isSelectedUser) {
        params.userId = this.isSelectedUser;
      }
      this.$http
        .post(url, params)
        .then(
          function(resp) {
            this.bindDeviceList = resp.data.data.list;
            this.page.total = resp.data.data.total;

            this.activeDeviceId = resp.data.data.list[0].device.id;
            this.activeUserName = resp.data.data.list[0].device.username;
            this.activeSerino = resp.data.data.list[0].device.serino;
            this.selectDevice = resp.data.data.list[0];
            this.searcheDialogVisible = false;
            this.getDeviceReportList();
            this.getDeviceTime();
            this.getDeviceHbTime();
            this.getDeviceRemain(this.activeDeviceId);
            this.getDeviceMaintain(this.activeDeviceId);
            this.getDeviceWarn(this.activeDeviceId);
          }.bind(this)
        )
        .catch((err) => {
          this.searcheDialogVisible = false;
          console.info(err);
        });
      loading.close();
    },
    addDeviceClick() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
         background: "rgba(0, 0, 0, 0.7)",
      });
      this.loading = loading;
      this.$refs["addDevice"].validate((valid) => {
        if (valid) {
          let params = new URLSearchParams();
          params.append("name", this.addDeviceForm.deviceName);
          params.append("typeid", this.addDeviceForm.deviceType);
          params.append("serino", this.addDeviceForm.serino);
          params.append("orino", this.addDeviceForm.serino);
          this.$http
            .post("/manage/device/add.do", params)
            .then(
              function(resp) {
                if (resp.data.success) {
                  this.$message.success(this.$t("m.alert.addSuccess"));
                  this.changeTab1();
                  this.addDeviceDialog = false;
                } else {
                  this.$message.error(this.$t("m.alert.addError"));
                }
              }.bind(this)
            )
            .catch((err) => err);
        }
      });
      loading.close();
    },
    getDeviceType() {
      this.$http
        .get("/manage/deviceType/list.do", {
          params: {
            pageNum: this.page.pageNum,
            pageSize: this.page.pageSize,
          },
        })
        .then(
          function(resp) {
            this.deviceList = resp.data.data;
            this.addDeviceForm.deviceTypeOptions = resp.data.data.list;
            this.addDeviceForm.deviceType = this.deviceList.list[0].id;
            //todo
            // this.devicePage.total=resp.data.total
            console.info(resp);
          }.bind(this)
        )
        .catch((err) => {
          console.info(err);
        });
    },
    deleteDevice() {
      this.$confirm(
        this.$t("m.alert.deleteConfirm"),
        this.$t("m.alert.reminder"),
        {
          confirmButtonText: this.$t("m.alert.confirm"),
          cancelButtonText: this.$t("m.alert.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          const loading = this.$loading({
            lock: true,
            text: "Loading",
            spinner: "el-icon-loading",
             background: "rgba(0, 0, 0, 0.7)",
          });
          this.loading = loading;
          let deviceId = this.activeDeviceId;
          var params = new URLSearchParams();
          params.append("deviceId", deviceId);
          this.$http
            .post("/manage/device/delDevice.do", params)
            .then(
              function(resp) {
                if (resp.data.success) {
                  this.$message.success(this.$t("m.alert.deleteSuccess"));
                  this.changeTab1();
                } else {
                  this.$message.error(this.$t("m.alert.deleteError"));
                }
              }.bind(this)
            )
            .catch((err) => {
              console.info(err);
            });
          loading.close();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("m.alert.cancelDelete"),
          });
        });
    },
    activeChange(e, val) {
      this.active1 = e;
      this.column = val;
      this.changeTab1();
    },
    reset() {
      this.params = { searchParamName: "deviceName", searchParamValue: "" };
      this.isSelectedUser = null;
      this.changeTab1();
    },
    bindDevice() {
      if (this.serino.trim().length <= 0) {
        this.$message.error(
          this.$t("m.deviceManage.bindDevice.dialog.bindDialog.placeholder")
        );
      } else {
        const loading = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
           background: "rgba(0, 0, 0, 0.7)",
        });
        this.loading = loading;
        let params = new URLSearchParams();
        params.append("ori", this.serino);
        this.$http
          .post("/manage/device/bindPC.do", params)
          .then(
            function(resp) {
              if (resp.data.success) {
                this.changeTab1();
                this.getCheckBindDevice();
                this.$message.success(this.$t("m.alert.updateSuccess"));
                this.deviceBindDialog = false;
              } else {
                this.$message.error(this.$t("m.alert.updateError"));
              }
            }.bind(this)
          )
          .catch((err) => {
            console.info(err);
          });
        loading.close();
      }
    },
    deviceUnbind() {
      this.$confirm(this.$t("m.alert.tip1"), this.$t("m.alert.reminder"), {
        confirmButtonText: this.$t("m.alert.confirm"),
        cancelButtonText: this.$t("m.alert.cancel"),
        type: "warning",
      })
        .then(() => {
          let bindId = this.activeDeviceId;
          console.log(this.activeDeviceId)
          var params = new URLSearchParams();
          params.append("deviceId", bindId);
          this.$http
            .post("/manage/device/unbind.do", params)
            .then(
              function(resp) {
                if (resp.data.success) {
                  this.$message.success(this.$t("m.alert.updateSuccess"));
                  this.changeTab1();
                  this.getCheckBindDevice();
                } else {
                  this.$message.error(this.$t("m.alert.updateError"));
                }
              }.bind(this)
            )
            .catch((err) => {
              console.info(err);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("m.alert.canceled"),
          });
        });
    },
    // 维保编辑
    deviceMaintainEdit(data) {
      if (!data) {
        this.maintainForm.content = "";
        this.maintainForm.id = "";
        this.isAddMaintain = true;
      } else {
        this.maintainForm.content = data.content;
        this.maintainForm.id = data.id;
        this.isAddMaintain = false;
      }
      //console.log(data);
      this.addMaintainDialog = true;
    },
    // 维保删除
    deviceMaintainDelete(data) {
      //let timeStr = this.$moment(data.createtime).format("YYYY-MM-DD");
      this.$confirm(
        this.$t("m.alert.deleteConfirm"),
        this.$t("m.alert.reminder"),
        {
          confirmButtonText: this.$t("m.alert.confirm"),
          cancelButtonText: this.$t("m.alert.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          let params = new URLSearchParams();
          params.append("id", data.id);
          params.append("delstatus", 1);
          params.append("type", 1);
          this.$http
            .post("/manage/deviceMaintain/update.do", params)
            .then(
              function(resp) {
                if (resp.data.success) {
                  this.$message.success(this.$t("m.alert.deleteSuccess"));
                  this.getCheckBindDevice();
                } else {
                  this.$message.error(this.$t("m.alert.deleteError"));
                }
              }.bind(this)
            )
            .catch((err) => {
              console.info(err);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("m.alert.cancelDelete"),
          });
        });
    },
    // 维保编辑
    deviceRemainEdit(data) {
      if (!data) {
        this.remainForm.type = "";
        this.remainForm.time = "";
        this.remainForm.content = "";
        this.remainForm.id = "";
        this.isAddRemain = true;
      } else {
        this.remainForm.type = data.typeNumber;
        this.remainForm.time = data.time;
        this.remainForm.content = data.content;
        this.remainForm.id = data.id;
        this.isAddRemain = false;
      }
      //console.log(data);
      this.addRemainDialog = true;
    },
    // 维保删除
    deviceRemainDelete(data) {
      //let timeStr = this.$moment(data.createtime).format("YYYY-MM-DD");
      this.$confirm(
        this.$t("m.alert.deleteConfirm"),
        this.$t("m.alert.reminder"),
        {
          confirmButtonText: this.$t("m.alert.confirm"),
          cancelButtonText: this.$t("m.alert.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          let params = new URLSearchParams();
          params.append("id", data.id);
          params.append("delstatus", 1);
          this.$http
            .post("/manage/deviceRemain/update.do", params)
            .then(
              function(resp) {
                if (resp.data.success) {
                  this.$message.success(this.$t("m.alert.deleteSuccess"));
                  this.getCheckBindDevice();
                } else {
                  this.$message.error(this.$t("m.alert.deleteError"));
                }
              }.bind(this)
            )
            .catch((err) => {
              console.info(err);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("m.alert.cancelDelete"),
          });
        });
    },
    addRemain() {
      //todo  添加表单验证
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
         background: "rgba(0, 0, 0, 0.7)",
      });
      this.loading = loading;
      let params = new URLSearchParams();
      params.append("deviceId", this.activeDeviceId);
      params.append("type", this.remainForm.type);
      params.append("time", this.remainForm.time);
      params.append("content", this.remainForm.content);
      this.remainForm.id && params.append("id", this.remainForm.id);
      if (this.isAddRemain) {
        this.$http
          .post("/manage/deviceRemain/add.do", params)
          .then(
            function(resp) {
              if (resp.data.success) {
                this.isAddRemain
                  ? this.$message.success(this.$t("m.alert.addSuccess"))
                  : this.$message.success(this.$t("m.alert.changeSuccess"));
                this.getCheckBindDevice();
                this.addRemainDialog = false;
              } else {
                this.isAddRemain
                  ? this.$message.error(this.$t("m.alert.addError"))
                  : this.$message.error(this.$t("m.alert.changeError"));
              }
            }.bind(this)
          )
          .catch((err) => {
            console.info(err);
          });
      } else {
        this.$http
          .post("/manage/deviceRemain/update.do", params)
          .then(
            function(resp) {
              if (resp.data.success) {
                this.isAddRemain
                  ? this.$message.success(this.$t("m.alert.addSuccess"))
                  : this.$message.success(this.$t("m.alert.changeSuccess"));
                this.getCheckBindDevice();
                this.addRemainDialog = false;
              } else {
                this.$message.error(resp.data.msg);
              }
            }.bind(this)
          )
          .catch((err) => {
            console.info(err);
          });
      }

      loading.close();
    },
    addMaintain() {
      //todo  添加表单验证
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
         background: "rgba(0, 0, 0, 0.7)",
      });
      this.loading = loading;
      let params = new URLSearchParams();
      params.append("deviceId", this.activeDeviceId);
      params.append("type", 1);
      /*params.append('item', this.maintainForm.item)
          params.append('worker', this.maintainForm.worker)*/
      params.append("content", this.maintainForm.content);
      this.maintainForm.id && params.append("id", this.maintainForm.id);

      if (this.isAddMaintain) {
        this.$http
          .post("/manage/deviceMaintain/add.do", params)
          .then(
            function(resp) {
              if (resp.data.success) {
                this.$message.success(this.$t("m.alert.addSuccess"));
                this.getCheckBindDevice();
                this.addMaintainDialog = false;
              } else {
                this.$message.error(this.$t("m.alert.addError"));
              }
            }.bind(this)
          )
          .catch((err) => {
            console.info(err);
          });
      } else {
        this.$http
          .post("/manage/deviceMaintain/update.do", params)
          .then(
            function(resp) {
              if (resp.data.success) {
                this.$message.success(this.$t("m.alert.changeSuccess"));
                this.getCheckBindDevice();
                this.addMaintainDialog = false;
              } else {
                this.$message.error(this.$t("m.alert.changeError"));
              }
            }.bind(this)
          )
          .catch((err) => {
            console.info(err);
          });
      }

      loading.close();
    },
    getUserList(query) {
      if (query !== '') {
        this.userLoading = true;
        const params = { pageNum: 1, pageSize: 50, keyword: query };
        this.$http.post('/manage/user/list', params).then(res => {
          this.userList = res.data.data.list;
          this.userLoading = false;
        }).catch(e => {
          this.userLoading = false;
        })
      } else {
        this.userList = [];
      }
    },
    getDeviceInfo() {
      this.$http.get(`/manage/metrics/get/${this.activeSerino}`).then(res => {
        if (res.data) {
          if (res.data.v1) {
            let item = res.data.v1.indicatorVoList;
            item.forEach(indicator => {
              switch (indicator.type) {
                case 1:
                  this.mqttInfo.sdTemperature = indicator?.value; // 豆温
                  break;
                case 2:
                  this.mqttInfo.inWindTemperature = indicator?.value; // 热风温
                  break;
                case 3:
                  this.mqttInfo.outSideTemperature = indicator?.value; // 环境温
                  break;
                case 4:
                  this.mqttInfo.outWindTemperature = indicator?.value; // 排风温
                  break;
                case 5:
                  this.mqttInfo.fire = indicator?.value; // 火力
                  break;
                case 6:
                  this.mqttInfo.wind = indicator?.value; // 风速
                  break;
                case 7:
                  this.mqttInfo.speed = indicator?.value; // 滚筒转速
                  break;
                case 8:
                  this.mqttInfo.cold = indicator?.value; // 冷却
                  break;
                default:
                  console.warn(`Unknown type: ${indicator.type}`);
              }
            });
          } else if (res.data.v2) {
            let item = JSON.parse(res.data.v2.content)
            this.mqttInfo = {
              sdTemperature: getDwValue(item), //豆温
              inWindTemperature: getRFWValue(item), //热风温
              outSideTemperature: getHJWValue(item), //环境温
              outWindTemperature: getPFWValue(item), //排风温
              fire: getHotValue(item),
              wind: getRfValue(item),
              speed: getGtValue(item),
              cold: getLQValue(item)
            }
        } else {
          this.mqttInfo = {
            sdTemperature: this.$t("m.deviceManage.bindDevice.notUpload"), //豆温
          inWindTemperature: this.$t("m.deviceManage.bindDevice.notUpload"), //热风温
          outSideTemperature: this.$t("m.deviceManage.bindDevice.notUpload"), //环境温
          outWindTemperature: this.$t("m.deviceManage.bindDevice.notUpload"), //排风温
          fire: this.$t("m.deviceManage.bindDevice.notUpload"),
          wind: this.$t("m.deviceManage.bindDevice.notUpload"),
          speed: this.$t("m.deviceManage.bindDevice.notUpload"),
          cold: this.$t("m.deviceManage.bindDevice.notUpload"),
        };
        }
      }
        }).catch(err => {
        console.error(err);
      });
    },
    handleCurveDeleted(id) {
      this.reportDetailDialog = false;
      this.getDeviceReportList();
    },
    toNewCurve(deviceId) {
      this.$router.push(`/on-curveList?deviceId=${deviceId}`);
    }
  },
};
</script>
<style lang="scss" scoped>
.table-footer {
  position: absolute;
  bottom: 0;
  background: #07080900;
  padding-top: 10px;
  right: 0;
  width: 100%;
}
::v-deep hover-row>td.el-table__cell  {
  background-color: none !important;
}
::v-deep .el-drawer__wrapper {
  background: #a6a6a6a1;
}
.header-btn {
  padding: 12px 15px;
  font-size: 14px;
  font-weight: bold;
}
.box-header-right {
  display: flex;
}
::v-deep .el-drawer__close-btn {color: #e2e2e2}
</style>
